import { Injectable } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';

@Injectable({
  providedIn: 'root'
})
export class ChatBotTranslateService {

  private translatorapiKey = '2bYnislgai8mD22rJDwQ7JcpVsehpY8rQjJAT51eGEM72UoqMGfJJQQJ99BBAC5RqLJXJ3w3AAAbACOGFarI';
  private apiUrl = `https://api.cognitive.microsofttranslator.com/translate?api-version=3.0`;
  public speechrapiKey = '2CEn4iusmdDqki2oQw3GZcKIQDukA4NX3kIYTTFMf8fPvgYn6F3JJQQJ99BBAC5RqLJXJ3w3AAAYACOGCB4I'
  public region = 'westeurope';
  private speechConfig: sdk.SpeechConfig;
  private synthesizer: sdk.SpeechSynthesizer;
  baseUrl = Constants.CORE_API_BASE_URL;
  constructor(
    private http: HttpClient
  ) {
    this.initializeSpeechConfig();
  }


  private initializeSpeechConfig(): void {
    this.speechConfig = sdk.SpeechConfig.fromSubscription(this.speechrapiKey, this.region);
    this.synthesizer = new sdk.SpeechSynthesizer(this.speechConfig);
  }


  translateText(text: string, targetLanguage: string): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.translatorapiKey,
      'Ocp-Apim-Subscription-Region': this.region,
      'Content-Type': 'application/json',
    });
    const body = [{ text: text }];
    return this.http.post(`${this.apiUrl}&to=${targetLanguage}`, body, { headers });
  }

  translateMessages(messages: any[], toLanguage: string): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.translatorapiKey,
      'Ocp-Apim-Subscription-Region': this.region,
      'Content-Type': 'application/json',
    });
    const body = messages.map(msg => ({ text: msg.content }));
    return this.http.post(`${this.apiUrl}&to=${toLanguage}`, body, { headers });
  }

  async getVoices(): Promise<sdk.VoiceInfo[]> {
    const synthesizer = new sdk.SpeechSynthesizer(this.speechConfig);
    const result = await synthesizer.getVoicesAsync();
    return result.voices;
  }

  async textToSpeech(text: string, voiceName?: string): Promise<void> {
    if (voiceName) {
      this.speechConfig.speechSynthesisVoiceName = voiceName;
    }

    return new Promise((resolve, reject) => {
      this.synthesizer.speakTextAsync(
        text,
        result => {
          if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
            resolve();
          } else {
            reject(result.errorDetails);
          }
          this.synthesizer.close();
        },
        error => {
          reject(error);
          this.synthesizer.close();
        }
      );
    });
  }

  getChatBotUserLanguages(): string[] {
    const configString = localStorage.getItem('user_chatbot_configurations');
    if (configString) {
      try {
        const config = JSON.parse(configString);
        if (config) {
          return config.language ? config.language.split(',') : [];
        } else {
          return [];
        }
      } catch (error) {
        console.error('Error parsing chatbot configurations:', error);
      }
    }
    return [];
  }


  getUserDefaultLanguage(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'UserChatbotConfiguration/getUserDefaultLanguage');
  }

  updateUserDefaultLanguage(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'UserChatbotConfiguration/updateUserDefaultLanguage', data);
  }

}
